import React from 'react';
const rows = [{
  dna: 'Integrated Chuck',
  benefit: 'Improved Accuracy - Less Stack Error - Reach your tolerances faster'
}, {
  dna: 'Direct Rotary Torque Table',
  benefit: 'Ultra Dynamic, High Precision, Less Wear - Ensures repeatable accuracy for the life of the machine - Made in GF Machining Solutions factory since 2001'
}, {
  dna: 'Step-Tec Spindle',
  benefit: 'High-RPM, High Power to size ratio, Designed to run full power around the clock, Dependable - Long service life, extreme precision'
}, {
  dna: 'Integrated Pallet Changer System',
  benefit: 'Unattended Machine Uptime - Industry leading affordability, FAST ROI'
}, {
  dna: 'Heidenhain CNC',
  benefit: 'Fully Loaded - Best in Class for High Speed 5-axis Machining - Take advantage of Mikron Smart Machining Modules'
}, {
  dna: 'Polymergranite Construction',
  benefit: 'Thermostability, Vibration Dampening, Heavy - Same Material Used On CMM - Handles high acceleration - Better surface finish - better accuracy control'
}, {
  dna: 'High Acceleration',
  benefit: 'Key to Fast Cycle Times & Long Tool Life - reduce heat build up in tool and workpiece material'
}, {
  dna: 'Symmetrical Design',
  benefit: 'High Accuracy, Ergonomics, Stability throughout the day'
}, {
  dna: 'Automation in Mind',
  benefit: 'Designed to be Modular & Scalable - Ergonomic - No operator obstruction'
}];
export function MikronDNASection() {
  return <section className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-2940">
      <div className="bg-[#1874cd] py-6 px-6" data-id="element-2941">
        <h2 className="text-3xl font-bold text-white text-center" data-id="element-2942">
          Mikron DNA
        </h2>
      </div>
      <div className="overflow-x-auto" data-id="element-2943">
        <table className="w-full text-left border-collapse" data-id="element-2944">
          <thead data-id="element-2945">
            <tr className="bg-gray-50 border-b border-gray-200" data-id="element-2946">
              <th className="py-4 px-6 font-bold text-navy text-lg text-center w-1/3" data-id="element-2947">
                DNA
              </th>
              <th className="py-4 px-6 font-bold text-navy text-lg text-center w-2/3" data-id="element-2948">
                User Benefit
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 text-gray-700 text-center" data-id="element-2949">
            {rows.map(row => <tr key={row.dna} className="hover:bg-gray-50 transition-colors" data-id="element-2950">
                <td className="py-4 px-6 font-bold text-navy" data-id="element-2951">{row.dna}</td>
                <td className="py-4 px-6" data-id="element-2952">{row.benefit}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}